// Maximum acceptable value of Integer
export const MAX_INT_32 = 2147483647;
export const ADMIN_API_SUCCESS_CODE = 1;
export const ACKNOWLEDGEABLE_SUCCESS_STATUS_CODES = [1, 101, 103, 105, 110, 113, 115, 122, 123, 201, 203, 205, 303, 305, 307];
export const ACKNOWLEDGEABLE_ERROR_STATUS_CODES = [2, 102, 104, 106, 111, 114, 116, 118, 121, 124, 202, 204, 206, 304, 306, 308];
export const PRACTICE_LOAD_STATUS_CODES = [101, 112, 113, 114, 122, 123, 124, 301, 302, 307, 308];